module.exports = __webpack_public_path__ + "static/img/101326.a76af622.png";